import * as React from 'react';
import { Form, Field, FormInput } from '@estee/elc-form';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { NotifyMeForm } from '../../domain/entities/NotifyMeForm';
import * as classnames from 'classnames';

export interface IProductNotifyMeForm {
    notifyMeForm: NotifyMeForm;
    emailInputPlaceholder: string;
    emailAddressRequired: string;
    isEmailValidMessage: string;
}

const StyledFormWrapper = styled.div`
    margin: 20px 0;
`;

const productNotifyMeFormWrapperClassNames = classnames(
    'elc-product-notify-me-form-wrapper',
    'js-product-notify-me-form-wrapper'
);

export const ProductNotifyMeFormComponent = observer((props: IProductNotifyMeForm) => {
    return (
        <Field
            name="userEmail"
            component={FormInput}
            inputLabel={props.emailInputPlaceholder}
            validations={{
                required: props.emailAddressRequired,
                email: props.isEmailValidMessage
            }}
            isRequired
            dataTestId="product_notify_me_email_input"
            inputType="email"
        />
    );
});

export const ProductNotifyMeForm = (props: IProductNotifyMeForm) => {
    return (
        <Form store={props.notifyMeForm}>
            <StyledFormWrapper className={productNotifyMeFormWrapperClassNames}>
                <ProductNotifyMeFormComponent {...props} />
            </StyledFormWrapper>
        </Form>
    );
};
